import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { installChunkLoadRecovery } from "./chunkLoadRecovery";
import { disablePwaCleanup } from "./disablePwaCleanup";

void disablePwaCleanup();
installChunkLoadRecovery();

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
